/* The separately owned GA4 stream follows Shopify's analytics permission. */
(function () {
  'use strict';
  var script = document.currentScript;
  var id = script && script.getAttribute('data-amazear-ga4');
  if (!/^G-[A-Z0-9]+$/.test(id || '')) return;
  var instance = '__amazearGa4_' + id;
  if (window[instance]) return;
  window[instance] = true;
  var disable = 'ga-disable-' + id;
  window[disable] = true;
  var initialized = false;
  var loadingPrivacy = false;
  function isAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return initialized && privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true && !window[disable];
  }
  window.AmazearAnalytics = {
    isAllowed: isAllowed,
    track: function (name, parameters) {
      if (!isAllowed()) return false;
      window.gtag('event', name, Object.assign({send_to: id, transport_type: 'beacon'}, parameters));
      return true;
    }
  };
  function ready() {
    if (typeof document.dispatchEvent === 'function') document.dispatchEvent(new window.Event('amazear:analytics-ready'));
  }

  function syncPermission() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return;
    var allowed = privacy.analyticsProcessingAllowed() === true;
    window[disable] = !allowed;
    if (!allowed) return;
    if (initialized) { ready(); return; }
    initialized = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    var existingTag = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
    if (!existingTag) {
      window.gtag('js', new Date());
      var tag = document.createElement('script');
      tag.async = true;
      tag.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
      document.head.appendChild(tag);
    }
    window.gtag('config', id, {
      allow_google_signals: false,
      allow_ad_personalization_signals: false
    });
    ready();
  }

  function loadPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      syncPermission();
    } else if (!loadingPrivacy && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      loadingPrivacy = true;
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) {
        if (!error) syncPermission();
      });
    }
  }

  document.addEventListener('visitorConsentCollected', syncPermission);
  window.addEventListener('load', loadPrivacy, {once: true});
  loadPrivacy();
}());
